export default __webpack_public_path__ + "static/media/Vol5Issue2.3fdf5654.png";